import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Companies from '@/components/Companies/Companies'
import addCompany from '@/components/Companies/addCompany'
import editCompany from '@/components/Companies/editCompany'
import Users from '@/components/Users/Users'
import addUser from '@/components/Users/addUser'
import editUser from '@/components/Users/editUser'
import profileEdit from '@/components/Users/profileEdit'
import Apms from '@/components/Apms/Apms'
import Info from '@/components/Apms/Info'
import apmParcels from '@/components/Apms/Parcels'
import parcelList_v2 from '@/components/Parcels/parcelList_v2'
import parcelInfo_v2 from '@/components/Parcels/parcelInfo_v2'
import Stats from '@/components/Apms/Stats'
import statsApm from '@/components/Stats/statsApm'
import statsApmClient from '@/components/Stats/statsApmClient'
import statsIndex from '@/components/Stats/statsIndex'
import statsMonth from '@/components/Stats/statsMonth'
import statsClient from '@/components/Stats/statsClient'
import statsClientMonth from '@/components/Stats/statsClientMonth'
import Corporations from '@/components/Corporations/Corporations'
import corporationUsers from '@/components/Corporations/corporationUsers'
import editCorporationsUser from '@/components/Corporations/editCorporationsUser'
import addCorporationsUser from '@/components/Corporations/addCorporationsUser'
import corporationParcels from '@/components/Corporations/corporationParcels'
import receivedReport from '@/components/ReceivedReport'
import troubleshooting from '@/components/Troubleshooting/troubleshooting'
import troubleshootingInfo from '@/components/Troubleshooting/troubleshootingInfo'
import generateParcel from '@/components/GenerateParcel'
import importParcels from '@/components/importParcels'
/*import generateInboxParcel from '@/components/GenerateInboxParcel'
import inbox from '@/components/Inbox/inbox'
import inboxParcelList from '@/components/Inbox/inboxParcelList'
import inboxParcelInfo from '@/components/Inbox/inboxParcelInfo'
import inboxUsers from '@/components/Inbox/inboxUsers'
import inboxUserInfo from '@/components/Inbox/inboxUserInfo'
import inboxUserAdd from '@/components/Inbox/inboxUserAdd'
*/
import generateLocalParcel from '@/components/GenerateLocalParcel'
import Locals from '@/components/Local/Locals'
import localParcelList from '@/components/Local/localParcelList'
import localParcelInfo from '@/components/Local/localParcelInfo'
import localUsers from '@/components/Local/localUsers'
import localUserInfo from '@/components/Local/localUserInfo'
import localUserAdd from '@/components/Local/localUserAdd'
import ChangePass from '@/components/ChangePass'
import generateAllClientParcel from '@/components/GenerateAllClientParcel'
import shParcelList from '@/components/Shophapiick/shParcelList'
import shParcelInfo from '@/components/Shophapiick/shParcelInfo'
import billing from '@/components/Billing/billing'
import inventory from '@/components/Inventory/inventory'
import stockList from '@/components/Inventory/stockList'
import stockInfo from '@/components/Inventory/stockInfo'
import stockAdd from '@/components/Inventory/stockAdd'
import stockProductDetails from '@/components/Inventory/stockProductDetails'
import stockReceive from '@/components/Inventory/stockReceive'
import actionList from '@/components/Inventory/actionList'
import actionAdd from '@/components/Inventory/actionAdd'
import actionInfo from '@/components/Inventory/actionInfo'
import columnList from '@/components/Inventory/columnList'
import columnBookingList from '@/components/Inventory/columnBookingList'
import columnBookingInfo from '@/components/Inventory/columnBookingInfo'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Login',
    component: Login
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  }, {
    path: '/companies',
    name: 'Companies',
    component: Companies
  }, {
    path: '/companies/edit/:id',
    name: 'editCompany',
    props: true,
    component: editCompany
  }, {
    path: '/companies/add',
    name: 'addCompany',
    component: addCompany
  }, {
    path: '/users',
    name: 'Users',
    component: Users
  }, {
    path: '/users/edit/:id',
    name: 'editUser',
    props: true,
    component: editUser
  }, {
    path: '/users/:localId/edit/:id',
    name: 'editUser',
    props: true,
    component: editUser
  }, {
    path: '/users/add',
    name: 'addUser',
    component: addUser
  }, {
    path: '/apms',
    name: 'Apms',
    component: Apms
  }, {
    path: '/apms/info/:id',
    name: 'Info',
    props: true,
    component: Info
  }, {
    path: '/apms/parcels/:id',
    name: 'Parcels',
    props: true,
    component: apmParcels
  }, {
    path: '/parcels_v2',
    name: 'parcelList_v2',
    component: parcelList_v2
  }, {
    path: '/parcels_v2/info/:from/:id',
    name: 'parcelInfo_v2',
    props: true,
    component: parcelInfo_v2
  }, {
    path: '/apms/stats/:id',
    name: 'Stats',
    props: true,
    component: Stats
  }, {
    path: '/stats/apms',
    name: 'statsApm',
    component: statsApm
  }, {
    path: '/stats/:client/:year/:month',
    name: 'statsClientMonth',
    props: true,
    component: statsClientMonth
  }, {
    path: '/users/profile',
    name: 'profileEdit',
    component: profileEdit
  }, {
    path: '/stats',
    name: 'statsIndex',
    component: statsIndex
  }, {
    path: '/stats/:year/:month',
    name: 'statsMonth',
    props: true,
    component: statsMonth
  }, {
    path: '/stats/:client',
    name: 'statsClient',
    props: true,
    component: statsClient
  }, {
    path: '/stats-apms/:client',
    name: 'statsApmClient',
    props: true,
    component: statsApmClient
  }, {
    path: '/corporations',
    name: 'Corporations',
    component: Corporations
  }, {
    path: '/corporations/:id/users',
    name: 'corporationUsers',
    props: true,
    component: corporationUsers
  }, {
    path: '/corporations/users',
    name: 'corporationUsers',
    component: corporationUsers
  }, {
    path: '/corporations/users/add',
    name: 'addCorporationsUser',
    component: addCorporationsUser
  }, {
    path: '/corporations/users/:userId/edit',
    name: 'editCorporationsUser',
    props: true,
    component: editCorporationsUser
  }, {
    path: '/corporations/:id/users/add',
    name: 'addCorporationsUser',
    props: true,
    component: addCorporationsUser
  }, {
    path: '/corporations/:id/users/:userId/edit',
    name: 'editCorporationsUser',
    props: true,
    component: editCorporationsUser
  }, {
    path: '/corporations/:id/parcels',
    name: 'corporationParcels',
    props: true,
    component: corporationParcels
  }, {
    path: '/receivedReport',
    name: 'receivedReport',
    props: true,
    component: receivedReport
  }, {
    path: '/troubleshooting',
    name: 'troubleshooting',
    props: true,
    component: troubleshooting
  }, {
    path: '/troubleshooting/info/:from/:id',
    name: 'troubleshootingInfo',
    props: true,
    component: troubleshootingInfo
  }, {
    path: '/generateParcel',
    name: 'generateParcel',
    props: true,
    component: generateParcel
  }, {
    path: '/importParcels',
    name: 'importParcels',
    props: true,
    component: importParcels
  },
  /*{
    path: '/inbox',
    name: 'inbox',
    component: inbox
  },{
    path: '/inbox/generateParcel',
    name: 'generateInboxParcel',
    component: generateInboxParcel
  }, {
    path: '/inbox/parcels',
    name: 'inboxParcelList',
    component: inboxParcelList
  },{
    path: '/inbox/:id/parcels',
    name: 'inboxParcelList',
    props: true,
    component: inboxParcelList
  }, {
    path: '/inbox/parcels/info/:id',
    name: 'inboxParcelInfo',
    props: true,
    component: inboxParcelInfo
  }, {
    path: '/inbox/:inboxId/parcels/:id/info',
    name: 'inboxParcelInfo',
    props: true,
    component: inboxParcelInfo
  },{
    path: '/inbox/users',
    name: 'inboxUsers',
    props: true,
    component: inboxUsers
  },{
    path: '/inbox/:id/users',
    name: 'inboxUsers',
    props: true,
    component: inboxUsers
  }, {
    path: '/inbox/users/info/:id',
    name: 'inboxUserInfo',
    props: true,
    component: inboxUserInfo
  }, {
    path: '/inbox/:inboxId/users/:id/info',
    name: 'inboxUserInfo',
    props: true,
    component: inboxUserInfo
  }, {
    path: '/inbox/users/add',
    name: 'inboxUserAdd',
    props: true,
    component: inboxUserAdd
  },{
    path: '/inbox/:id/users/add',
    name: 'inboxUserAdd',
    props: true,
    component: inboxUserAdd
  },*/{
    path: '/local',
    name: 'Locals',
    component: Locals
  }, {
    path: '/local/generateParcel',
    name: 'generateLocalParcel',
    component: generateLocalParcel
  }, {
    path: '/local/parcels',
    name: 'localParcelList',
    component: localParcelList
  }, {
    path: '/local/:id/parcels',
    name: 'localParcelList',
    props: true,
    component: localParcelList
  }, {
    path: '/local/parcels/info/:id',
    name: 'localParcelInfo',
    props: true,
    component: localParcelInfo
  }, {
    path: '/local/:localId/parcels/:id/info',
    name: 'localParcelInfo',
    props: true,
    component: localParcelInfo
  }, {
    path: '/local/users',
    name: 'localUsers',
    props: true,
    component: localUsers
  }, {
    path: '/local/:id/users',
    name: 'localUsers',
    props: true,
    component: localUsers
  },
  //{
  //  path: '/local/:localId/users/:id/info',
  //  name: 'localUserInfo',
  //  props: true,
  //  component: localUserInfo
  //},
  {
    path: '/local/users/info/:id',
    name: 'localUserInfo',
    props: true,
    component: localUserInfo
  }, {
    path: '/local/users/add',
    name: 'localUserAdd',
    props: true,
    component: localUserAdd
  },
  //{
  //  path: '/local/:id/users/add',
  //  name: 'localUserAdd',
  //  props: true,
  //  component: localUserAdd
  //},
  {
    path: '/changepass',
    name: 'ChangePass',
    props: true,
    component: ChangePass
  }, {
    path: '/generateallclientparcel',
    name: 'GenerateAllClientParcel',
    props: true,
    component: generateAllClientParcel
  },
  {
    path: '/history',
    name: 'shParcelList',
    component: shParcelList
  },
  {
    path: '/history/parcel/:from/:id',
    name: 'shParcelInfo',
    props: true,
    component: shParcelInfo
  }, {
    path: '/billing',
    name: 'Billing',
    component: billing
  }, {
    path: '/inventory',
    name: 'inventory',
    component: inventory
  }, {
    path: '/inventory/stock/list',
    name: 'stockList',
    component: stockList
  }, {
    path: '/inventory/stock/info/:stock_id/:store_id',
    name: 'stockInfo',
    props: true,
    component: stockInfo
  }, {
    path: '/inventory/stock/detail/:stock_product_id',
    name: 'stockProductDetails',
    props: true,
    component: stockProductDetails
  }, {
    path: '/inventory/stock/add',
    name: 'stockAdd',
    component: stockAdd
  }, {
    path: '/inventory/stock/receive',
    name: 'stockReceive',
    component: stockReceive
  }, {
    path: '/inventory/action/list',
    name: 'ActionList',
    component: actionList
  }, {
    path: '/inventory/action/add',
    name: 'actionAdd',
    //props: true,
    component: actionAdd
  }, {
    path: '/inventory/action/info/:id',
    name: 'actionInfo',
    props: true,
    component: actionInfo
  }, {
    path: '/inventory/column/list',
    name: 'columnList',
    //props: true,
    component: columnList
  }, {
    path: '/inventory/column/reservation/list',
    name: 'columnBookingList',
    component: columnBookingList
  }, {
    path: '/inventory/column/reservation/info/:id',
    name: 'columnBookingInfo',
    props: true,
    component: columnBookingInfo
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js